// adapted from https://github.com/lukeed/clsx
// MIT License
// Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

function toVal(mix: string | number | Record<string, unknown> | Array<string | number | Record<string, unknown>>) {
  let k,
    y,
    str = "";

  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (typeof mix === "object") {
    if (Array.isArray(mix)) {
      const len = mix.length;
      for (k = 0; k < len; k++) {
        if (mix[k] && (y = toVal(mix[k]))) {
          if (str) {
            str += " ";
          }
          str += y;
        }
      }
    } else {
      for (y in mix) {
        if (mix[y]) {
          if (str) {
            str += " ";
          }
          str += y;
        }
      }
    }
  }

  return str;
}

/**
 * utility for constructing className strings conditionally.
 * Important: Any falsey values are discarded!
 */
export function clsx(...args: Array<string | number | Record<string, unknown> | undefined>) {
  let i = 0,
    tmp,
    x,
    str = "";
  const len = args.length;
  for (; i < len; i++) {
    if ((tmp = args[i]) && (x = toVal(tmp))) {
      if (str) {
        str += " ";
      }
      str += x;
    }
  }
  return str;
}
